module.exports = __webpack_public_path__ + "static/media/ppt.17d9bc6e.svg";